import styled from 'styled-components';

export const StyledA = styled.a`
  text-decoration:none;
  display: flex;
  align-items: center;
  &:hover,
  &:focus{
    text-decoration:none;
    outline:none;
  }
  + & {margin-left:1.2rem;}
`;